import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCSHqgUwOQWU0IAgxFSeV0ltQQpNvqVTvI",
  authDomain: "kaonr-front.firebaseapp.com",
  projectId: "kaonr-front",
  storageBucket: "kaonr-front.firebasestorage.app",
  messagingSenderId: "295221500338",
  appId: "1:295221500338:web:00e3b01df7404b0ad4acab",
  measurementId: "G-XMLKD36D71"
};

import { connectAuthEmulator } from "firebase/auth";
import { connectFirestoreEmulator } from "firebase/firestore";

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

// ローカル開発環境（localhost）の場合、エミュレータに接続する
if (location.hostname === "localhost") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, 'localhost', 8081);
}

export { auth, db };
